<div class="order-ship-form--container lum-modal">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loadingPickingItems"
    [classes]="'loading'"
  ></div>
  <div class="lum-modal__header flex justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">{{ data.title }} </span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>

  <ng-container *ngIf="shippableOrders.length === 1">
    <div
      class="alert alert-warning my-5"
      role="alert"
      *ngIf="shippableOrders[0]?.channel?.warehouse_group?.pick_and_pack_enabled"
    >
      Note: The default&nbsp;<i>{{
        shippableOrders[0]?.channel?.warehouse_group?.label
      }}</i
      >&nbsp; Warehouse Group is set to manual configuration and cannot be
      overridden.
    </div>
    <div
      class="alert alert-warning my-5"
      role="alert"
      *ngIf="!shippableOrders[0]?.hasPushOrderIntegrationMapping"
    >
      Warning: The channel&nbsp;<i>{{ shippableOrders[0]?.channel?.label }}</i
              >&nbsp;has Push Orders to Integration toggled off.
    </div>
    <div class="row py-5" [formGroup]="formData">
      <div class="col-4">
        <div class="form-group">
          <label for="">Fulfillment Order Key</label>
          <input
            class="lum-input"
            type="text"
            formControlName="fulfillmentOrderKey"
          />
        </div>
      </div>
      <div
        class="col-8 d-flex align-items-end"
        [hidden]="!showDestinationOmsStoresDropdown && !('red_DV-3395_channel_types' | featureFlag)"
      >
        <div class="form-group">
                  <mat-checkbox formControlName="pushToOms" class="lum-checkbox">
          Push To Integration
        </mat-checkbox>
        </div>
      </div>
      <ng-container *ngIf="!('red_DV-3395_channel_types' | featureFlag); else channelTypesEnabled">
        <div class="col-4">
          <div class="form-group">
            <label for="">Fulfillment Warehouse Group</label>
            <lum-location-warehouse-group-control
              formControlName="warehouseGroupId"
              [disabled]="
              shippableOrders[0]?.channel?.warehouse_group?.pick_and_pack_enabled
            "
              [externalParams]="{ pickAndPackEnabled: 'false' }"
            ></lum-location-warehouse-group-control>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="">Fulfillment Destination</label>
            <lum-app-integration-account-control
              [appAccountType]="supportedDestinationOmsAppTypes"
              (onAppAccountSelect)="onSelectDestinationOms($event)"
              formControlName="destinationOmsId"
            ></lum-app-integration-account-control>
          </div>
        </div>
        <div class="col-4" [hidden]="!showDestinationOmsStoresDropdown">
          <div class="form-group">
            <label for="">Destination OMS Store</label>
            <lum-app-integration-account-oms-store-control
              [appIntegrationAccountId]="selectedDestinationOmsId"
              formControlName="destinationOmsStoreId"
            ></lum-app-integration-account-oms-store-control>
          </div>
        </div>
      </ng-container>
      <ng-template #channelTypesEnabled>
        <div class="col-4">
          <div class="form-group">
            <label for="">Fulfillment Channel</label>
            <lum-fulfillment-channel-control
              [channelTypes]="fulfillmentChannelTypes"
              formControlName="fulfillmentChannelId"
            ></lum-fulfillment-channel-control>
          </div>
        </div>
      </ng-template>
    </div>
  </ng-container>

  <mat-dialog-content>
    <div class="order-ship-form--content mt-3 py-3">
      <ng-container *ngIf="shippableOrders.length > 0; else empty">
        <h6 class="shippable"> Fulfillable Orders ({{ shippableOrders.length }}) </h6>
        <table class="shippable table table-stripped">
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th>Order Date</th>
              <th>Order ID</th>
              <th>Order #</th>
              <th class="text-right">Total</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let order of shippableOrders; trackBy: trackById">
              <tr>
                <td>
                  <button
                    type="button"
                    class="lum-button lum-button--link p-2"
                    (click)="onToggleOrder(order.id)"
                  >
                    <i
                      class="fas pr-2"
                      [ngClass]="{
                        'fa-chevron-right': !order.isExpanded,
                        'fa-chevron-down': order.isExpanded,
                      }"
                    ></i>
                  </button>
                </td>
                <td>
                  {{ order.orderDate | date: 'mediumDate' }}
                </td>
                <td>
                  {{ order.orderId }}
                </td>
                <td>
                  {{ order.orderNumber }}
                </td>
                <td class="text-right">
                  {{ order.orderTotal | currency: '' }}
                </td>
                <td class="text-right">
                  <ng-container *ngIf="order.isIncluded; else isExcluded">
                    <span
                      class="shipping text-info"
                      *ngIf="order.shippingStatus === shippingStatus.SHIPPING"
                    >
                      Shipping <i class="fas fa-spinner fa-spin"></i>
                    </span>
                    <span
                      class="shipping text-red-600"
                      *ngIf="order.shippingStatus === shippingStatus.FAILED"
                    >
                      FAILED
                      <span *ngIf="order.shippingError">
                        [{{ order.shippingError }}]
                      </span>
                    </span>
                    <span
                      class="shipping text-green-700"
                      *ngIf="order.shippingStatus === shippingStatus.SHIPPED"
                    >
                      SHIPPED
                    </span>
                  </ng-container>
                  <ng-template #isExcluded>
                    <span class="shipping text-yellow-800"> EXCLUDED </span>
                  </ng-template>
                </td>
              </tr>
              <tr *ngIf="order.isExpanded">
                <td class="p-1 pb-4 bg-gray-100" colspan="12">
                  <table class="w-100">
                    <thead>
                      <tr>
                        <th style="width: 98px" class="p-2">
                          <div class="d-flex align-items-center">
                            <mat-checkbox
                              class="lum-checkbox mr-2"
                              [checked]="isAllOrderItemsSelected(order)"
                              [indeterminate]="isSomeOrderItemsSelected(order)"
                              (change)="onToggleAllOrderItems(order.id, $event.checked)"
                              [disabled]="!canOverride || !hasSelectableItems(order)"
                            ></mat-checkbox>
                            <span>Include</span>
                          </div>
                        </th>
                        <th class="p-2">Item SKU</th>
                        <th class="p-2">Item Name</th>
                        <th class="p-2">Item Quantity</th>
                        <th
                          class="p-2"
                          *ngIf="
                            canOverride && 'red_DV-3362_fo_shipment_splits'
                              | featureFlag
                          "
                          >Lot</th
                        >
                        <th class="p-2 text-nowrap text-right">Available Qty</th>
                        <th class="p-2">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container
                        *ngFor="let item of order.orderItems; trackBy: trackById"
                      >
                        <tr
                          [ngClass]="{
                            'bg-red-300': item.errorMessage !== null,
                            'split-child': item.id !== (item.parent_id || item.id),
                            'split-parent': item.id === (item.parent_id || item.id),
                          }"
                        >
                          <td class="p-2">
                            <ng-container
                              *ngIf="
                                item.id === (item.parent_id || item.id) &&
                                  item.status !== salesOrderStatus.SHIPPED &&
                                  item.quantityRemaining !== 0;
                                else cantBeIncluded
                              "
                            >
                              <mat-checkbox
                                class="lum-checkbox"
                                [disabled]="
                                  item.status === salesOrderStatus.SHIPPED ||
                                  !canOverride
                                "
                                [checked]="item.isIncluded"
                                (change)="onToggleItem(order.id, item.id)"
                              ></mat-checkbox>
                            </ng-container>
                            <ng-template #cantBeIncluded>
                              <span> </span>
                            </ng-template>
                          </td>
                          <td class="p-2">
                            {{ item.sku }}
                          </td>
                          <td class="p-2">
                            {{ item.name }}
                          </td>
                          <td class="p-2">
                            <div class="flex gap-2 text-align-center w-70">
                              <ng-container
                                *ngIf="
                                  item.status !== salesOrderStatus.SHIPPED &&
                                    item.quantityRemaining !== 0;
                                  else shippedItem
                                "
                              >
                                <div class="w-50">
                                  <input
                                    type="number"
                                    inputmode="numeric"
                                    class="lum-input lum-input--small"
                                    [ngClass]="{
                                      'lum-input--negative':
                                        item.quantityOverridden < 1 ||
                                        item.quantityOverridden >
                                          item.quantityRemaining,
                                    }"
                                    lumPreventScroll
                                    lumInvalidNumberInput
                                    [value]="item.quantityOverridden"
                                    (input)="onUpdateQuantity(item.id, $event)"
                                    [disabled]="!canOverride || item.isSplitSource"
                                  />
                                </div>
                                <div class="w-50 pt-2">
                                  / {{ item.quantityRemaining | decimalPlaces }}
                                </div>
                              </ng-container>
                              <ng-template #shippedItem>
                                {{ item.quantityFulfilled | decimalPlaces }} /
                                {{ item.quantity | decimalPlaces }}
                              </ng-template>
                            </div>
                          </td>
                          <td
                            *ngIf="
                              canOverride && 'red_DV-3362_fo_shipment_splits'
                                | featureFlag
                            "
                          >
                            <ng-container *ngIf="item.lotTracking">
                              <div class="lot-row">
                                <input
                                  [(ngModel)]="item.lot"
                                  (focus)="
                                    onLoadLots(item.rfqId ?? item.rfq_id, item)
                                  "
                                  (debounceValue)="
                                    onSearchLot(
                                      $event,
                                      item.rfqId ?? item.rfq_id,
                                      item
                                    )
                                  "
                                  [matAutocomplete]="autoSearchLot"
                                  [debounceTime]="1000"
                                  [disabled]="item.quantityRemaining === 0"
                                  lumDebounceTime
                                  type="text"
                                  class="lum-input lot-input"
                                />

                                <ng-container
                                  *ngIf="item.id === (item.parent_id || item.id)"
                                >
                                  <button
                                    type="button"
                                    class="lum-button lum-button--link px-2 py-1 lot-split-button"
                                    (click)="splitOrderItem(order, item)"
                                    [disabled]="!canOverride"
                                  >
                                    Split
                                  </button>
                                </ng-container>
                                <ng-container
                                  *ngIf="
                                    item.parent_id && item.id !== item.parent_id
                                  "
                                >
                                  <button
                                    type="button"
                                    class="lum-button lum-button--link px-2 py-1 lot-split-button"
                                    (click)="removeSplitItem(order, item)"
                                  >
                                    Remove
                                  </button>
                                </ng-container>
                              </div>

                              <mat-autocomplete
                                [displayWith]="displayFnLot"
                                #autoSearchLot="matAutocomplete"
                              >
                                <mat-option
                                  disabled
                                  class="loading"
                                  *ngIf="item.loadingLots; else lotOptions"
                                >
                                  <mat-spinner diameter="25"></mat-spinner>
                                </mat-option>

                                <ng-template #lotOptions>
                                  <mat-option
                                    *ngFor="
                                      let lot of item.lots;
                                      trackBy: trackByControlValue
                                    "
                                    [value]="lot"
                                  >
                                    {{ lot?.lot_number }}
                                  </mat-option>
                                </ng-template>
                              </mat-autocomplete>
                            </ng-container>
                          </td>

                          <td class="p-2 pt-4 text-right">
                            <ng-container
                              *ngIf="item.id === (item.parent_id || item.id)"
                            >
                              {{ item.availableQuantity | decimalPlaces }}
                            </ng-container>
                          </td>
                          <td class="pt-4 text-right text-nowrap">
                            <ng-container
                              *ngIf="item.id === (item.parent_id || item.id)"
                            >
                              <ng-container
                                *ngIf="item.errorMessage !== null; else qtyShipped"
                              >
                                <span class="shipping text-info">
                                  {{ item.errorMessage }}
                                </span>
                              </ng-container>
                              <ng-template #qtyShipped>
                                <span
                                  *ngIf="item.status !== salesOrderStatus.PENDING"
                                  class="shipping text-info font-weight-bold pt-2"
                                >
                                  {{ item.quantityFulfilled | decimalPlaces }}
                                  Fulfilled
                                </span>
                              </ng-template>
                            </ng-container>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </ng-container>
      <ng-template #empty>
        <div class="text-red-500">No orders can be shipped.</div>
      </ng-template>
    </div>
    <div class="order-ship-form--content mt-3 py-3">
      <ng-container *ngIf="nonShippableOrders.length > 0">
        <h6 class="non-shippable">These orders can't be shipped due to:</h6>
        <table class="non-shippable table table-stripped">
          <thead>
            <tr>
              <th style="width: 120px">Order Date</th>
              <th>Order ID</th>
              <th>Order #</th>
              <th class="text-right">Total</th>
              <th>Error(s)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of nonShippableOrders; trackBy: trackById">
              <td style="width: 120px">
                {{ order.orderDate | date: 'mediumDate' }}
              </td>
              <td>{{ order.orderId }}</td>
              <td>{{ order.orderNumber }}</td>
              <td class="text-right">{{ order.orderTotal | currency: '' }}</td>
              <td class="non-shippable-error--message text-red-600">
                <span *ngIf="order.errors.missingBillingDetails">{{
                  orderShippingErrors.MISSING_BILLING_DETAILS
                }}</span>
                <span *ngIf="order.errors.missingShippingDetails">{{
                  orderShippingErrors.MISSING_SHIPPING_DETAILS
                }}</span>
                <span *ngIf="order.errors.isCancelledOrder">{{
                  orderShippingErrors.ORDER_CANCELLED
                }}</span>
                <span *ngIf="order.errors.hasShipstationOrderId">{{
                  orderShippingErrors.SHIPSTATION_EXISTS
                }}</span>
                <span *ngIf="order.errors.isTransferOrder">{{
                  orderShippingErrors.IS_TRANSFER_ORDER
                }}</span>
                <span *ngIf="order.errors.isShipstation">{{
                  orderShippingErrors.IS_SHIPSTATION
                }}</span>
                <span *ngIf="order.errors.isPosted">{{
                  orderShippingErrors.NOT_POSTED
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      type="button"
      class="lum-button lum-button--tertiary mr-2"
      mat-button
      (click)="onClose()"
    >
      Close
    </button>
    <button
      (click)="onConfirmShipOrders()"
      [disabled]="
        disableConfirmShipOrders ||
        hasInvalidItemQuantities ||
        (shippableOrders.length === 1 && !formData.valid)
      "
      mat-button
      type="button"
      class="lum-button"
    >
      Confirm and Save Fulfillment Order
    </button>
  </mat-dialog-actions>
</div>
